const tr: any = {
  title: {
    fr: "Popcard Reviews (Carte Avis)",
    ar: "Popcard Reviews (Carte Avis)",
    en: "Popcard Reviews (Review Card)",
  },
  description: {
    fr: (
      <>
        Optimisez votre réputation en ligne avec nos cartes d&apos;avis Black
        Premium dédiées à Google Reviews et à toutes les autres plateformes
        d&apos;évaluation.
        <br />
        <br />
        Encouragez vos clients à laisser des avis positifs en toute simplicité
        et améliorez votre visibilité !
      </>
    ),
    ar: "حسّن سمعتك على الإنترنت باستخدام بطاقات المراجعات Black Premium المخصصة لـ Google Reviews وجميع المنصات الأخرى. شجع عملائك على ترك مراجعات إيجابية بسهولة وزد من ظهورك!",
    en: (
      <>
        Optimize your online reputation with our Black Premium review cards
        dedicated to Google Reviews and all other review platforms.
        <br />
        <br />
        Encourage your customers to leave positive reviews with ease and enhance
        your visibility!
      </>
    ),
  },
  ameliore: {
    fr: "Améliore votre réputation en ligne",
    ar: "تحسن سمعتك على الإنترنت",
    en: "Improves your online reputation",
  },
  collectAvis: {
    fr: "Collecte des avis positifs en temps réel",
    ar: "جمع التقييمات الإيجابية في الوقت الفعلي",
    en: "Collects positive reviews in real time",
  },
  feedBack: {
    fr: "Facilite le processus de feedback pour vos clients",
    ar: "يسهل عملية الملاحظات لعملائك",
    en: "Makes the feedback process easy for your customers",
  },
  compatible: {
    fr: "Compatible avec toutes les plateformes d’évaluation en ligne",
    ar: "متوافق مع جميع منصات التقييم عبر الإنترنت",
    en: "Compatible with all online review platforms",
  },
  qrCodeImprime: {
    fr: "Qr code imprimé sur le dos de la carte pour les téléphones non compatibles avec NFC",
    ar: "رمز الاستجابة السريعة (QR code) مطبوع على الجزء الخلفي من البطاقة للهواتف غير المتوافقة مع تقنية NFC.",
    en: "QR code printed on the back of the card for phones not compatible with NFC",
  },
  Pesonalization: {
    fr: "Personnalisation avec votre logo",
    ar: "تخصيص بطاقتك بشعارك الخاص",
    en: "Customization with your logo",
  },
  detailedStatictics: {
    fr: "Statistiques détaillées (Popcard Metrics)",
    ar: "إحصائيات مفصلة (بوبكارد ميتريكس)",
    en: "Detailed statistics (Popcard Metrics)",
  },
  colors: {
    fr: "Colors",
    ar: "الألوان",
    en: "Colors",
  },
  fullName: {
    fr: "Nom et Prénom*",
    ar: "الاسم الكامل *",
    en: "Full Name*",
  },
  enterprise: {
    fr: "Entreprise ou Métier*",
    ar: "الشركة أو الأعمال *",
    en: "Company or Profession*",
  },
  email: {
    fr: "Adresse Email*",
    ar: "البريد الإلكتروني *",
    en: "Email Address*",
  },
  phone: {
    fr: "Téléphone*",
    ar: "الهاتف",
    en: "Phone*",
  },
  address: {
    fr: "Adresse Exacte *",
    ar: "العنوان*",
    en: "Exact Address*",
  },
  city: {
    fr: "Ville *",
    ar: "المدينة *",
    en: "City*",
  },
  qty: {
    fr: "Quantité*",
    ar: "الكمية *",
    en: "Quantity*",
  },
  codePromo: {
    fr: "Code Promo",
    ar: "كوبون",
    en: "Promo Code",
  },
  livraison: {
    fr: "Livraison gratuite partout au maroc",
    ar: "توصيل مجاني في أي مكان في المغرب",
    en: "Free delivery anywhere in Morocco",
  },
  Confirmer: {
    fr: "Confirmer",
    ar: "تأكيد الطلب",
    en: "Confirm",
  },
  mad: {
    fr: "MAD",
    ar: "درهم",
    en: "MAD",
  },
};

export default tr;
